/* Copyright (c) Trimble Inc. All rights reserved. */

export const ACTION_STATUS = {
    INIT: 'INIT',
    LOADING: 'LOADING',
    INTERMEDIATE: 'INTERMEDIATE',
    LOADED: 'LOADED',
    ERROR: 'ERROR',
  } as const;
  export type ActionStatusType = keyof typeof ACTION_STATUS;
  
  // Async Call - State Declaration Type
  export interface AsyncActionState<U = unknown> {
    status: ActionStatusType;
    value?: U | null;
    init: boolean;
    loading: boolean;
    intermediate: boolean;
    loaded: boolean;
    error: any;
  }
  